import QuizIcon from '@mui/icons-material/Quiz';

export const StudyFormIcon = QuizIcon;
